// PM Feedback Batch 1, item 1 (2026-09) — shared status -> copy/pill map for the agency-facing
// "My requests" list + detail views. Mirrors modules/build.py::AGENCY_QUOTE_REQUEST_STATUSES.
export const STATUS_META = {
  "Submitted": { label: "Submitted", pillClass: "ag-pill-neutral", next: "NJM will pick this up shortly. We'll update this page the moment there's news." },
  "In review": { label: "In review", pillClass: "ag-pill-gold", next: "NJM is actively reviewing your production requirements." },
  "Quote sent": { label: "Quote sent", pillClass: "ag-pill-green", next: "Your NJM contact will share the formal quote with you." },
  "Call requested": { label: "Call requested", pillClass: "ag-pill-gold", next: "NJM would like a short call to confirm a few details before quoting. Your NJM contact will reach out." },
  "Declined": { label: "Declined", pillClass: "ag-pill-red", next: "NJM isn't able to take this on right now." },
  "Closed": { label: "Closed", pillClass: "ag-pill-neutral", next: "This request is closed." },
};

export const STATUS_STEPS = ["Submitted", "In review", "Quote sent"];
